// Add this to your TIL Management page or admin dashboard

import React, { useState } from 'react';
import { Button, Alert, CircularProgress, Box, Typography } from '@mui/material';
import { PlayArrow as ProcessIcon, CheckCircle as SuccessIcon } from '@mui/icons-material';
import axiosInstance from '../utils/axiosConfig';

const ProcessTILButton: React.FC = () => {
  const [processing, setProcessing] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  const handleProcessTIL = async () => {
    try {
      setProcessing(true);
      setError(null);
      setResult(null);

      const response = await axiosInstance.post('/api/performances/process-til');
      
      setResult(response.data);
      
    } catch (err: any) {
      console.error('Error processing TIL:', err);
      setError(err.response?.data?.message || 'Failed to process TIL');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Button
        variant="contained"
        color="primary"
        size="large"
        startIcon={processing ? <CircularProgress size={20} sx={{ color: 'white' }} /> : <ProcessIcon />}
        onClick={handleProcessTIL}
        disabled={processing}
        sx={{ 
          bgcolor: '#3A9188',
          '&:hover': { bgcolor: '#2D7A72' },
          px: 4,
          py: 1.5
        }}
      >
        {processing ? 'Processing TIL...' : 'Process All Backlog TIL'}
      </Button>

      {result && (
        <Alert severity="success" sx={{ mt: 2 }}>
          <Typography variant="body2" gutterBottom>
            <strong>✅ TIL Processing Complete!</strong>
          </Typography>
          <Typography variant="body2">
            Found {result.totalFound} performances to process
          </Typography>
          {result.results && (
            <Typography variant="body2">
              Successfully processed: {result.results.filter((r: any) => r.success).length} performances
            </Typography>
          )}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default ProcessTILButton;